<template>
    <div id="bottom-up-products-tab" class="w-full">
        <div class="card-holder">
            <AonContainer>
                <AonRow class="mt-5">
                    <AonCol class="aon-col-12 pa-0" style="position: relative; min-height: 300px">
                        <BottomUpProductsSummaryCard
                            :data="productSummaryData"
                            :loading="loadProductSummary"
                            class="grey05"
                        />
                    </AonCol>
                </AonRow>
                <AonRow class="mt-5">
                    <AonCol class="aon-col-12 pa-0" style="position: relative; min-height: 300px">
                        <EntityConceptFlatListCard
                            :globalLoading="loadProductSummary"
                            class="grey05"
                        />
                    </AonCol>
                </AonRow>
            </AonContainer>
        </div>
    </div>
</template>

<script setup>
import { inject, onMounted, ref, watch } from 'vue'
import BottomUpProductsSummaryCard from '@/components/company/tabs/bottomUpProducts/BottomUpProductSummaryCard.vue'
import { useEntityStore } from '@/stores'
import { getConceptSummaries } from '@/api/entities'
import EntityConceptFlatListCard from '@/components/company/tabs/bottomUpProducts/EntityConceptFlatListCard.vue'

const entityStore = useEntityStore()

const logger = inject('logger')

const loadProductSummary = ref(true)
const productSummaryData = ref(null)

onMounted(async () => {
    await fetchProductSummary()
})

watch(
    () => entityStore.entity?.aon_entity_pk,
    async (newVal) => {
        if (newVal) {
            loadProductSummary.value = true
            await fetchProductSummary()
        }
    }
)

const fetchProductSummary = async () => {
    if (entityStore.entity?.aon_entity_pk) {
        try {
            const { data } = await getConceptSummaries(entityStore.entity.aon_entity_pk)

            productSummaryData.value = data
            loadProductSummary.value = false
        } catch (error) {
            logger.error(error)
        }
    }
}
</script>

<style scoped lang="scss"></style>
